/**
 * 缓存清理时间管理工具
 */

const STORAGE_KEY_LAST_CLEAR = 'cache_last_clear_time'
const STORAGE_KEY_LAST_SILENT_CLEAR = 'cache_last_silent_clear_time'
const CLEAR_INTERVAL_MINUTES = 30 // 30分钟

/**
 * 获取上次手动清理缓存的时间戳
 * @returns {number | null} 时间戳（毫秒），如果没有记录则返回 null
 */
export function getLastClearTime() {
  const timeStr = localStorage.getItem(STORAGE_KEY_LAST_CLEAR)
  return timeStr ? parseInt(timeStr, 10) : null
}

/**
 * 记录手动清理缓存的时间
 * @param {number} timestamp 时间戳（毫秒），如果不提供则使用当前时间
 */
export function setLastClearTime(timestamp = Date.now()) {
  localStorage.setItem(STORAGE_KEY_LAST_CLEAR, timestamp.toString())
}

/**
 * 获取上次静默清理缓存的时间戳
 * @returns {number | null} 时间戳（毫秒），如果没有记录则返回 null
 */
export function getLastSilentClearTime() {
  const timeStr = localStorage.getItem(STORAGE_KEY_LAST_SILENT_CLEAR)
  return timeStr ? parseInt(timeStr, 10) : null
}

/**
 * 记录静默清理缓存的时间
 * @param {number} timestamp 时间戳（毫秒），如果不提供则使用当前时间
 */
export function setLastSilentClearTime(timestamp = Date.now()) {
  localStorage.setItem(STORAGE_KEY_LAST_SILENT_CLEAR, timestamp.toString())
}

/**
 * 检查是否需要清理缓存（距离上次清理超过30分钟）
 * @returns {boolean} 如果需要清理返回 true，否则返回 false
 */
export function shouldClearCache() {
  // 优先检查手动清理时间，如果没有则检查静默清理时间
  const lastClearTime = getLastClearTime() || getLastSilentClearTime()
  
  if (!lastClearTime) {
    // 如果从来没有清理过，返回 true
    return true
  }
  
  const now = Date.now()
  const diffMinutes = (now - lastClearTime) / (1000 * 60)
  
  return diffMinutes >= CLEAR_INTERVAL_MINUTES
}

/**
 * 获取距离上次清理的分钟数
 * @returns {number | null} 分钟数，如果没有记录则返回 null
 */
export function getMinutesSinceLastClear() {
  const lastClearTime = getLastClearTime() || getLastSilentClearTime()
  
  if (!lastClearTime) {
    return null
  }
  
  const now = Date.now()
  return Math.floor((now - lastClearTime) / (1000 * 60))
}
